import { post } from "../../request";

/**
 * 获取奖品列表
 * @param data
 * @returns {*}
 */
export function prizeIndex(data) {
  return post("admin/UserScoreRedeemPrize/index", data);
}

/**
 * 新增奖品
 * @param data
 * @returns {*}
 */
export function addPrize(data) {
  return post("admin/UserScoreRedeemPrize/add", data);
}

/**
 * 编辑奖品
 * @param data
 * @returns {*}
 */
export function editPrize(data) {
  return post("admin/UserScoreRedeemPrize/edit", data);
}

/**
 * 删除奖品
 * @param data
 * @returns {*}
 */
export function deletePrize(data) {
  return post("admin/UserScoreRedeemPrize/delete", data);
}

/**
 * 设置启用奖品
 * @param data
 * @returns {*}
 */
export function setEnable(data) {
  return post("admin/UserScoreRedeemPrize/setEnable", data);
}

/**
 * 佣金流水列表
 * @param data
 * @returns {*}
 */
export function withdrawalIndex(data) {
  return post("admin/UserCommissionWithdrawal/index", data);
}

/**
 * 佣金流水审核通过
 * @param data
 * @returns {*}
 */
export function withdrawalPass(data) {
  return post("admin/UserCommissionWithdrawal/pass", data);
}

/**
 * 佣金流水驳回
 * @param data
 * @returns {*}
 */
export function withdrawalReject(data) {
  return post("admin/UserCommissionWithdrawal/reject", data);
}

/**
 * 积分流水
 * @param data
 * @returns {*}
 */
export function scoreFlowIndex(data) {
  return post("admin/UserScoreFlowRecord/index", data);
}
